(function(){
var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;

document.querySelectorAll('.rbt [data-split]').forEach(function(el){
var d=el.getAttribute('data-d')||'0';
var words=el.textContent.split(' ');
el.textContent='';
words.forEach(function(w,i){
var s=document.createElement('span');
s.className='rbt-tw__w';
s.textContent=w+(i<words.length-1?'\u00A0':'');
s.style.transitionDelay=(parseFloat(d)*.08 + i*.06)+'s';
el.appendChild(s);
});
});
var revealEls=document.querySelectorAll('.rbt [data-r], .rbt [data-split]');
var countEls=document.querySelectorAll('[data-c]');
var dots=document.querySelectorAll('.rbt-dt'),ais=document.querySelectorAll('.rbt-ai');
var faqItems=document.querySelectorAll('.rbt-fi');
var fnItems=document.querySelectorAll('.rbt-fn__item'),fnImgs=document.querySelectorAll('.rbt-fn__preview img');
var fnCap=document.getElementById('rbt-fn-cap');
var rcSteps=document.querySelectorAll('#rbt-rcst .rbt-rc__s');
function setExpanded(el,val){if(el)el.setAttribute('aria-expanded',val?'true':'false')}
function setPressed(el,val){if(el)el.setAttribute('aria-pressed',val?'true':'false')}

if('IntersectionObserver' in window){
var io=new IntersectionObserver(function(e){
e.forEach(function(x){if(x.isIntersecting){x.target.classList.add('v');io.unobserve(x.target)}})
},{threshold:.12});
revealEls.forEach(function(el){io.observe(el)});

var sio2=new IntersectionObserver(function(e){
e.forEach(function(x){
if(x.isIntersecting){
rcSteps.forEach(function(s,i){setTimeout(function(){s.classList.add('v')},i*90)});
sio2.disconnect();
}
})
},{threshold:.15});
if(rcSteps[0]) sio2.observe(rcSteps[0]);
}else{
revealEls.forEach(function(el){el.classList.add('v')});
rcSteps.forEach(function(s){s.classList.add('v')});
}

var sk=document.getElementById('rbt-sk'),hr=document.getElementById('rbt-hr');
if(sk&&hr&&'IntersectionObserver' in window){
var sio=new IntersectionObserver(function(e){
e.forEach(function(x){sk.classList.toggle('v',!x.isIntersecting&&x.boundingClientRect.top<0)})
},{threshold:0});
sio.observe(hr);
}

function easeOutExpo(t){return t===1?1:1-Math.pow(2,-10*t)}
function ac(el){
var t=parseInt(el.dataset.t,10),s=el.dataset.s||'',st=performance.now(),dur=1800;
(function step(n){
var p=Math.min((n-st)/dur,1);
el.textContent=Math.round(easeOutExpo(p)*t)+s;
if(p<1)requestAnimationFrame(step);
else{var n2=el.closest('.rbt-st__n');if(n2){n2.classList.add('pop');setTimeout(function(){n2.classList.remove('pop')},320)}}
})(st);
}
if('IntersectionObserver' in window){
var cio=new IntersectionObserver(function(e){e.forEach(function(x){if(x.isIntersecting){ac(x.target);cio.unobserve(x.target)}})},{threshold:.5});
countEls.forEach(function(el){cio.observe(el)});
}else{
countEls.forEach(function(el){el.textContent=(el.dataset.t||'')+(el.dataset.s||'')});
}

function actHS(id){
dots.forEach(function(d){var active=d.dataset.t===id;d.classList.toggle('a',active);setPressed(d,active)});
ais.forEach(function(a){var active=a.dataset.i===id;a.classList.toggle('a',active);setExpanded(a.querySelector('.rbt-ab'),active)});
}
dots.forEach(function(d){d.addEventListener('click',function(){actHS(d.dataset.t)})});
ais.forEach(function(a){a.querySelector('.rbt-ab').addEventListener('click',function(){actHS(a.dataset.i)})});

var iw=document.getElementById('rbt-iw'),iwIn=document.getElementById('rbt-iw-in');
if(iw&&iwIn&&!reduced&&window.matchMedia('(hover: hover)').matches){
var rx=0,ry=0,tx=0,ty=0,raf=null;
function render(){tx+=(rx-tx)*.12;ty+=(ry-ty)*.12;iwIn.style.transform='rotateX('+ty+'deg) rotateY('+tx+'deg)';if(Math.abs(rx-tx)>.05||Math.abs(ry-ty)>.05){raf=requestAnimationFrame(render)}else{raf=null}}
iw.addEventListener('mousemove',function(e){
var r=iw.getBoundingClientRect();
var x=(e.clientX-r.left)/r.width-.5;
var y=(e.clientY-r.top)/r.height-.5;
rx=x*8;ry=-y*8;
if(!raf)raf=requestAnimationFrame(render);
});
iw.addEventListener('mouseleave',function(){rx=0;ry=0;if(!raf)raf=requestAnimationFrame(render)});
}

faqItems.forEach(function(f){
f.querySelector('.rbt-fib').addEventListener('click',function(){
var o=f.classList.contains('o');
faqItems.forEach(function(x){x.classList.remove('o');setExpanded(x.querySelector('.rbt-fib'),false)});
if(!o){f.classList.add('o');setExpanded(f.querySelector('.rbt-fib'),true)}
});
});

fnItems.forEach(function(it){
it.addEventListener('click',function(){
var img=it.dataset.img;
fnItems.forEach(function(i){i.classList.remove('a');setPressed(i,false)});
it.classList.add('a');setPressed(it,true);
fnImgs.forEach(function(im){im.classList.toggle('a',im.dataset.fn===img)});
if(fnCap){var nm=it.querySelector('.rbt-fn__info strong');if(nm)fnCap.textContent=nm.textContent}
});
});

document.querySelectorAll('[data-ripple]').forEach(function(b){
b.addEventListener('click',function(e){
var r=b.getBoundingClientRect();
var size=Math.max(r.width,r.height);
var sp=document.createElement('span');sp.className='rp';
sp.style.width=sp.style.height=size+'px';
sp.style.left=(e.clientX-r.left-size/2)+'px';
sp.style.top=(e.clientY-r.top-size/2)+'px';
b.appendChild(sp);
setTimeout(function(){sp.remove()},700);
});
});

if(!reduced&&window.matchMedia('(hover: hover)').matches){
document.querySelectorAll('[data-magnet]').forEach(function(b){
b.addEventListener('mousemove',function(e){
var r=b.getBoundingClientRect();
var x=(e.clientX-r.left-r.width/2)/r.width;
var y=(e.clientY-r.top-r.height/2)/r.height;
b.style.transform='translate('+(x*8)+'px,'+(y*6 - 2)+'px)';
});
b.addEventListener('mouseleave',function(){b.style.transform=''});
});
}

if(!reduced){
var parEls=document.querySelectorAll('[data-parallax]');
var ticking=false;
function onScroll(){
if(ticking)return;
ticking=true;
requestAnimationFrame(function(){
var vh=window.innerHeight;
parEls.forEach(function(el){
var r=el.getBoundingClientRect();
if(r.bottom<-100||r.top>vh+100)return;
var speed=parseFloat(el.dataset.parallax)||.15;
var center=r.top+r.height/2-vh/2;
var y=-center*speed;
el.style.transform='translate3d(0,'+y.toFixed(1)+'px,0)';
});
ticking=false;
});
}
window.addEventListener('scroll',onScroll,{passive:true});
onScroll();
}

var tiltImg=document.querySelector('[data-tilt]');
if(tiltImg&&!reduced&&window.matchMedia('(hover: hover)').matches){
var tp=tiltImg.parentElement;
tp.addEventListener('mousemove',function(e){
var r=tp.getBoundingClientRect();
var x=(e.clientX-r.left)/r.width-.5;
var y=(e.clientY-r.top)/r.height-.5;
tiltImg.style.transform='perspective(1000px) rotateX('+(-y*4)+'deg) rotateY('+(x*6)+'deg) scale(1.02)';
});
tp.addEventListener('mouseleave',function(){tiltImg.style.transform=''});
}
})();